import { call, put } from 'redux-saga/effects'
import { makeAccess } from '../../../../../config/factory-controller'
import type { ApiResponse } from '../../../../../config/api-types'
import type { GetCollectionOrderStatusRequest } from '../../../domain/models/get-collection-order-status'
import { GetCollectionOrderStatusService } from '../../../service/get-collection-order-status-service'
import { apiConfig } from '../../../../../config/api-config'
import { GetCollectionOrderStatusRepository } from '../../../data/repositories/get-collection-order-status-repository'
import { GetCollectionOrderStatusController } from '../../controllers/get-collection-order-status-controller'
import * as action from '../actions/get-collection-order-status-actions'

export const controller = async (payload: GetCollectionOrderStatusRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new GetCollectionOrderStatusService(apiConfig(key, token))
  const repository = new GetCollectionOrderStatusRepository(dataSource)
  const control = new GetCollectionOrderStatusController(repository)
  return await control.getStatus(payload)
}

export function* getCollectionOrderStatusSaga({ payload }: any): any {
  try {
    const result: ApiResponse = yield call(controller, payload)
    yield put(action.getCollectionOrderStatusSuccess(result))
  } catch (error: any) {
    yield put(action.getCollectionOrderStatusError(error.toString()))
  }
}